import Home from "@/components/app/Home.vue";

import Settings from "@/components/app/Settings.vue";
import Bookmarks from "@/components/app/Bookmarks.vue";
import Progress from "@/components/app/Progress.vue";
import ViewBook from "@/components/app/books/ViewBook.vue";
import Books from "@/components/app/Books.vue";
import Messages from "@/components/app/Messages.vue";
import BookInformation from "@/components/app/books/BookInformation.vue";
import ChangePassword from "@/components/app/ChangePassword.vue";
import Logout from "@/components/app/Logout.vue";
import Feedback from "@/components/app/Feedback.vue";

let appRoutes = [
    {
        path: '/',
        name: 'pages.home',
        component: Home,
        meta: {
            public: false,
        },
    },
    {
        path: '/books',
        name: 'pages.books',
        component: Books,
        meta: {
            public: false,
        },
    },
    {
        path: '/voortgang',
        name: 'pages.progress',
        component: Progress,
        meta: {
            public: false,
        },
    },
    {
        path: '/bookmarks',
        name: 'pages.bookmarks',
        component: Bookmarks,
        meta: {
            public: false,
        },
    },
    {
        path: '/settings',
        name: 'pages.settings',
        component: Settings,
        meta: {
            public: false,
        },
    },
    {
        path: '/messages',
        name: 'pages.messages',
        component: Messages,
        meta: {
            public: false,
        },
    },
    {
        path: '/change-password',
        name: 'pages.changepassword',
        component: ChangePassword,
        meta: {
            public: false,
        },
    },
    {
        path: '/feedback',
        name: 'pages.feedback',
        component: Feedback,
        meta: {
            public: false,
        },
    },
    {
        path: '/logout',
        name: 'pages.logout',
        component: Logout,
        meta: {
            public: false,
        },
    },
    {
        path: '/book/:id',
        name: 'pages.book',
        component: ViewBook,
        meta: {
            public: false,
        },
    },
    {
        path: '/book-information/:id',
        name: 'pages.bookInfo',
        component: BookInformation,
        meta: {
            public: false,
        },
    },
];

export {
    appRoutes,
};
